import "./why.css";

export default function Why() {
  return (
    <>
      {/* <div className="why-container container mt-5">
        <div className="row justify-content-between">
          <div className="why-box col-md-4 col-sm-12 mb-4">
            <span className="why-sub">01 / Born to Brand</span>
            <h3 className="why-title">Elevate Your Presence</h3>
            <p>
              As Navi Mumbai’s India leading advertising and brand identity agency, we don’t just build brands — we craft powerful identities that truly resonate.
              Our expert team takes the time to understand your business, analyze your goals, and develop a cohesive and compelling brand presence.
              In today’s competitive market, we ensure your brand stands out through an integrated approach that reflects clarity, creativity, and consistency.
            </p>
          </div>
          <div className="why-box col-md-4 col-sm-12 mb-4">
            <span className="why-sub">02 / Strategic Creativity</span>
            <h3 className="why-title">Creativity That Speaks for Your Brand</h3>
            <p>
              We craft communication that doesn’t just inform—but engages, inspires, and positions your brand at the forefront of your audience’s mind.
              You know your target audience—we help you speak to them in the most creative and meaningful way possible.
            </p>
          </div>
          <div className="why-box col-md-4 col-sm-12 mb-4">
            <span className="why-sub">03 / 360° Marketing Solutions</span>
            <h3 className="why-title">Your Brand Our Mission 360° Marketing Solutions.</h3>
            <p>
              Our expert team offers high-impact SEO, SEM, and social media services to elevate your brand’s online presence. From strategic planning to campaign optimization, we deliver measurable results by analyzing past metrics and creating data-driven strategies. Partner with the best advertising agency in Navi Mumbai to achieve success across all digital platforms.
            </p>
          </div>
        </div>
      </div> */}
      <div className="heading yh2">
        <h2>Why Choose Twinkle Media Hub</h2>
      </div>
      <section className="Homestrategy" aria-label="Why Choose Twinkle Media Hub">
        <div className="Homestrategy-card">
          <i className="fa-solid fa-lightbulb"></i>
          {/* <span>01 / Born to Brand</span> */}
          <h3>Build a Strong Digital Presence</h3>
          <p>We help brands create a clear, consistent, and professional presence across all digital platforms. By understanding your business, audience, and goals, we design branding and marketing strategies that truly represent who you are and what you stand for.

</p>
          <p>Our focus is on clarity, consistency, and long-term brand value.</p>
        </div>

        <div className="Homestrategy-card">
          <i className="fa-solid fa-wand-magic-sparkles"></i>
          {/* <span>02 / Strategic Creativity</span> */}
          <h3>Creativity That Connects</h3>
          <p >Creativity is not just about good design—it’s about meaningful communication. We create content and campaigns that engage, inspire, and connect with your audience in a natural and authentic way. You know your business best—we turn that knowledge into creative stories that people remember.</p>
        </div>
        <div className="Homestrategy-card">
          <i className="fa-solid fa-globe"></i>
          {/* <span>03 / 360° Marketing Solutions</span> */}
          <h3>360° Marketing That Delivers Results</h3>
          <p>From SEO and social media marketing to websites, ads, and video production, we offer complete 360° digital solutions under one roof. Every strategy is planned, executed, and optimized to deliver measurable results.</p>
          <p>Our goal is simple: help your brand grow consistently across all digital channels.</p>
        </div>
      </section >
    </>
  );
}
